module.exports = __webpack_public_path__ + "img/hero-3.1c559c17.png";